import { getScore } from "utils/dateTimeUtils";

export const createCelebration = (person, dateType) => ({
  person,
  key: `${person.id}${dateType}`,
  dateType,
  score: getScore(person[dateType]),
});
